// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"3355":"c1604e04","3869":"c1604e04"}[chunkId] + ".chunk.css");